import { TicketSelectionApplicationData } from "@/domain/ticket-selection";
import { Hold, PriceLevel, PromotionHold } from "webshop-api";

export class PriceListOrderingProvider {

    public static provideCorrectPriceListOrder(data: TicketSelectionApplicationData): TicketSelectionApplicationData {
        if (!data.priceList) {
            return data;
        }

        if (!data.priceList.priceLevels || !data.priceList.priceLevels.length) {
            return data;
        }

        data.priceList.priceLevels = data.priceList.priceLevels
            .map(priceLevel => this.toSortedPromotionHolds(priceLevel))
            .sort((a, b) => a.number! - b.number!);

        return data;
    }

    /**
     * whatItDoes
     * maps sorted PromotionHolds to priceLevel
     */
    private static toSortedPromotionHolds(priceLevel: PriceLevel): PriceLevel {
        if (!priceLevel.promotionHolds) { return priceLevel; }

        priceLevel.promotionHolds = priceLevel.promotionHolds.map(promotionHold => this.toSortedHolds(promotionHold));

        return priceLevel;
    }

    /**
     * whatItDoes
     * sorts Holds by number property value
     */
    private static toSortedHolds(promotionHold: PromotionHold): PromotionHold {
        if (!promotionHold.holds) { return promotionHold; }

        promotionHold.holds = promotionHold.holds
            .map(hold => this.toSortedTicketTypes(hold))
            .sort((a, b) => a.number! - b.number!);

        return promotionHold;
    }

    /**
     * whatItDoes
     * sorts TicketTypes by number property value
     */
    private static toSortedTicketTypes(hold: Hold): Hold {
        if (!hold.ticketTypes) { return hold; }

        hold.ticketTypes = hold.ticketTypes.sort((a, b) => a.number! - b.number!);

        return hold;
    }

}
